var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.76269C4.5 2.16564 5.8133 0.870972 7.43333 0.870972H9.56667C11.1867 0.870972 12.5 2.16564 12.5 3.76269V5.86576C12.5 6.30132 12.1418 6.65441 11.7 6.65441H5.3C4.85817 6.65441 4.5 6.30132 4.5 5.86576V3.76269ZM7.43333 2.44827C6.69695 2.44827 6.1 3.03676 6.1 3.76269V5.07711H10.9V3.76269C10.9 3.03676 10.303 2.44827 9.56667 2.44827H7.43333Z",
    fill: "#C6E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61939 3.68779C2.75424 3.62406 2.90396 3.72549 2.90369 3.87292L2.9 5.86577C2.9 7.17244 3.97452 8.23172 5.3 8.23172H11.7C13.0255 8.23172 14.1 7.17244 14.1 5.86577V3.87232C14.1 3.72506 14.2496 3.62389 14.3843 3.68755C15.6484 4.28498 16.5 5.55743 16.5 7.00715V18.0371C16.5 19.8361 15.1407 21.3533 13.3299 21.5756C10.1224 21.9694 6.87764 21.9694 3.6701 21.5756C1.85927 21.3533 0.5 19.8361 0.5 18.0371V7.00715C0.5 5.55762 1.35505 4.28532 2.61939 3.68779ZM11.7 11.1234C12.1418 11.1234 12.5 11.4765 12.5 11.9121C12.5 12.3476 12.1418 12.7007 11.7 12.7007H5.3C4.85817 12.7007 4.5 12.3476 4.5 11.9121C4.5 11.4765 4.85817 11.1234 5.3 11.1234H11.7ZM10.6333 14.278C11.0752 14.278 11.4333 14.6311 11.4333 15.0667C11.4333 15.5022 11.0752 15.8553 10.6333 15.8553H5.3C4.85817 15.8553 4.5 15.5022 4.5 15.0667C4.5 14.6311 4.85817 14.278 5.3 14.278H10.6333Z",
    fill: "#C6E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.33a322ecb7fc690c25368cc10c0da3ff.svg";
export { ForwardRef as ReactComponent };